import { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { TextField, PrimaryButton, Dropdown, DefaultButton } from 'office-ui-fabric-react';
import { History } from "history";
import 'react-sortable-tree/style.css';
import { RootState } from 'app/redux/reducer';
import { deleteSpecification, getSpecifications, getSpecificationTypes, ISpecification, ISpecificationType } from 'app/services/specification';
import { IList, IListFilter, IListState, StatusEnum } from 'app/shared';
import { castThunkAction } from 'app/utils/casting';
import PageTitle from 'components/customs/PageTitle';
import { toggleConfirmDialog } from 'app/redux/system/actions';
import { deleteRecovery, getRecoveries, updateRecovery } from 'app/services/recovery';
import { toggleModal } from 'app/redux/modal/actions';
import BasicTable from 'components/customs/BasicTable';
import { RouteComponentProps } from 'react-router';
import PageLayout from 'containers/PageLayout';

interface OwnProps {
    history: History<any>,
}

function mapStateToProps(state: RootState, ownProps: RouteComponentProps) {
    return {
        ...ownProps,
        defaultLanguage: state.system.defaultLanguage,
        language: state.system.language,
        specificationTypes: state.specification.specificationTypes as IList<ISpecificationType[]>,
        specifications: state.specification.specifications as IList<ISpecification[]>,
    }
}

function mapDispatchToProps(dispatch: Dispatch) {
    return bindActionCreators({
        toggleConfirmDialog,
        getRecoveries,
        updateRecovery,
        deleteRecovery,
        getSpecifications,
        deleteSpecification,
        getSpecificationTypes,
        toggleModal
    }, dispatch);
}

type IListSpecificationProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps;

class ListSpecification extends Component<IListSpecificationProps, IListState> {

    state = {
        type: "specification",
        filterObject: {
            title: "",
            status: 1,
            createdOn: "",
            typeKey: "",
            language: this.props.defaultLanguage
        },
        pagerObject: {
            page: 1,
            descending: false,
            pageSize: 10
        },
        activeStatus: StatusEnum.Published
    }

    componentDidMount() {
        this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })
        this.props.getSpecificationTypes({ page: 1, pageSize: 1000, descending: false, language: this.props.defaultLanguage });
        window.addEventListener("keydown", this.onEnterSearch, true);
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.onEnterSearch, true);
    }

    onEnterSearch = (e: any) => {
        if (e.key === "Enter") {
            this.searchList();
        }
    };


    makeRequest(options: IListFilter) {
        if (this.state.filterObject.status === StatusEnum.Deleted) {
            castThunkAction(this.props.getRecoveries(options, this.state.type))
                .then(() => {
                    this.setState({
                        activeStatus: StatusEnum.Deleted,
                    })
                })
        } else {
            castThunkAction(this.props.getSpecifications(options)).then(() => {
                this.setState({
                    activeStatus: this.state.filterObject.status,
                })
            })
        }
    }

    searchList() {
        this.setState({
            pagerObject: {
                page: 1,
                descending: false,
                pageSize: 10
            },
        }, () => {
            this.makeRequest({
                ...this.state.pagerObject,
                ...this.state.filterObject
            })
        })
    }

    renderFilter() {
        return (
            <div className="table-filter row">
                <TextField
                    className="custom-textfield col-md-2"
                    label="Başlık İle Arama"
                    value={this.state.filterObject?.title || ""}
                    autoFocus
                    onChange={(event: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                "title": event.target.value
                            }
                        })
                    }}
                />
                <Dropdown
                    selectedKey={this.state.filterObject.typeKey || ""}
                    label="Kategoriye Göre Arama"
                    calloutProps={{ className: "custom-dropdown-callout" }}
                    className="custom-dropdown border col-md-2"
                    onChange={(event: any, option: any) => this.setState({
                        filterObject: {
                            ...this.state.filterObject as any,
                            typeKey: option?.key
                        }
                    })}
                    options={([{ id: "", title: "Tümü", key: "" }, ...(this.props.specificationTypes?.list || [])]).map(item => ({ key: item.key, text: item.title }))}
                />
                {/* <Dropdown
                    options={[
                        { key: StatusEnum.Draft, text: "Taslak" },
                        { key: StatusEnum.Published, text: "Yayında" }
                    ]}
                    className="custom-dropdown col-md-2"
                    label="Duruma Göre Arama"
                    placeholder="Seçiniz"
                    selectedKey={this.state.filterObject?.status}
                    onChange={(event: any, option: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                "status": option.key
                            }
                        })
                    }}
                    calloutProps={{
                        className: "custom-dropdown-callout"
                    }}
                />
                <DayPickerInput onChange={(createdOn: string) => this.setState({
                    filterObject: {
                        ...this.state.filterObject,
                        createdOn
                    }
                })} /> */}
                <PrimaryButton
                    text="Arama Yap"
                    className="custom-button"
                    onClick={() => this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })}
                    styles={{
                        root: {
                            fontSize: "11px",
                            marginTop: "27px",
                            height: "30px"
                        }
                    }}
                />
            </div>
        )
    }

    renderList() {
        return (
            <BasicTable
                columns={[
                    {
                        columnName: "title",
                        text: "Spesifikasyon Adı",
                        col: "col-md-9"
                    },
                    {
                        columnName: "key",
                        text: "Spesifikasyon Tipi",
                        col: "col-md-3",
                        onRender: (item) => {
                            if (!item.key) return "-";
                            return (
                                <span style={{ padding: "5px", background: "#62a98e", color: "#fff", marginBottom: "-12.5px" }}>{item["key"]}</span>
                            )
                        }
                    }
                ]}
                items={this.props.specifications.list}
                renderOperations={(item: ISpecification) => (this.state.activeStatus !== StatusEnum.Deleted ?
                    <>
                        <div className="more" onClick={() => this.props.toggleModal("specification", item)}><i className="icon-edit-outline"></i> Düzenle</div>
                        <button onClick={() => {
                            this.props.toggleConfirmDialog(true, {
                                callback: () => {
                                    castThunkAction(this.props.deleteSpecification(item.id as string)).then(res => {
                                        if (res) {
                                            this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })
                                        }
                                    })
                                }
                            })
                        }}><i className="icon-trash-outline"></i> Sil</button>
                    </> : <>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => {
                            castThunkAction(this.props.updateRecovery(this.state.type, item.id as string)).then(res => {
                                if (res) {
                                    this.searchList()
                                }
                            })

                        }}><i className="icon-trash-outline"></i> Kurtar</a>
                        <button onClick={() => {
                            this.props.toggleConfirmDialog(true, {
                                callback: () => {
                                    castThunkAction(this.props.deleteRecovery(item.id as string)).then(res => {
                                        if (res) {
                                            this.searchList()
                                        }
                                    })
                                }
                            })
                        }}><i className="icon-trash-outline"></i> Kalıcı Olarak Sil</button>
                    </>
                )
                }
                showPager={true}
                pageCount={this.props.specifications.pageCount}
                totalCount={this.props.specifications.totalCount}
                onChangePageSize={(pageSize) => {
                    this.setState({ pagerObject: { ...this.state.pagerObject, pageSize } }, () => this.makeRequest({
                        ...this.state.pagerObject,
                        ...this.state.filterObject,
                        pageSize
                    }))
                }}
                onChangePager={(pageNumber) => {
                    this.setState({ pagerObject: { ...this.state.pagerObject, page: pageNumber } }, () => this.makeRequest({
                        ...this.state.pagerObject,
                        ...this.state.filterObject,
                        page: pageNumber
                    }))
                }}
                pageIndex={this.state.pagerObject.page - 1}
            />
        )
    }

    render() {
        return (
            <PageLayout history={this.props.history} match={this.props.match} location={this.props.location}>
                <div className="page push-all">
                    <PageTitle
                        title="Spesifikasyon Yönetimi"
                        subTitle="Tüm spesifikasyonları aşağıdan görüntüleyebilir, düzenleme yapabilir veya yeni bir spesifikasyon ekleyebilirsiniz."
                        backUrl="/"
                        showBack
                        history={this.props.history}
                    />
                    <div className="absolute-create absolute-wrapper row">
                        <DefaultButton
                            onClick={() => this.props.history.push("/specification-types")}
                            iconProps={{ iconName: "ProductionFloorManagement" }}
                            text="Spesifikasyon Kategori Yönetimi"
                        />
                        <PrimaryButton
                            onClick={() => this.props.toggleModal("specification", {})}
                            iconProps={{ iconName: "Add" }}
                            text="Yeni Spesifikasyon Ekle"
                            styles={{
                                root: {
                                    background: "#62a98e",
                                    borderColor: "#5b9e85",
                                    color: "#fff"
                                },
                                rootHovered: {
                                    background: "#5b9e85",
                                    borderColor: "#5b9e85"
                                },
                                rootDisabled: {
                                    background: "#ececec"
                                }
                            }}
                        />
                    </div>
                    {this.renderFilter()}
                    {this.renderList()}
                </div>
            </PageLayout>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListSpecification);